const getters = {
  token: state => state.user.token,
  usercode: state => state.user.usercode,
  username: state => state.user.username,
  department: state => state.user.department,
  avatar: state => state.user.avatar,
  approval: state => state.user.approval,
  roles: state => state.user.roles,
  worktimes: state => state.count.worktimes,
  workovers: state => state.count.workovers,
  vsurplus: state => state.count.vsurplus,
  osurplus: state => state.count.osurplus,
  // 教育积分审批权限
  point_admin_power: state => state.pointvuex.point_admin_power,
  // 积分列表---（未审批  已审批  已拒绝）
  point_list_status: state => state.pointvuex.point_list_status,
  // 审批页面
  point_to_apply: state => state.pointvuex.point_to_apply
}
export default getters
